import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Clock } from "lucide-react";
import { cn } from "@/lib/utils";

function formatWhen(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      weekday: "short", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function UpcomingAppointments({ appointments = [] }) {
  return (
    <Card className="shadow-sm" data-testid="upcoming-appointments">
      <CardHeader className="pb-2">
        <CardTitle className="font-heading text-base font-semibold text-slate-900">Upcoming Appointments</CardTitle>
        <p className="text-xs text-slate-400">Next scheduled patient visits</p>
      </CardHeader>
      <CardContent className="space-y-3">
        {appointments.map((a) => (
          <div
            key={a.id}
            className="flex items-center gap-3 rounded-lg border border-slate-100 p-3 transition-colors hover:border-slate-200 hover:bg-slate-50"
            data-testid="appointment-item"
          >
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-emerald-50 text-emerald-600">
              <Clock className="h-4 w-4" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-slate-900">{a.patient_name}</p>
              <p className="truncate text-xs text-slate-500">{a.type} · {a.doctor}</p>
            </div>
            <div className="text-right">
              <p className="font-mono text-xs text-slate-600">{formatWhen(a.scheduled_at)}</p>
              <Badge
                className={cn(
                  "mt-1 capitalize",
                  a.status === "confirmed"
                    ? "bg-emerald-50 text-emerald-700 hover:bg-emerald-50"
                    : "bg-amber-50 text-amber-600 hover:bg-amber-50"
                )}
              >
                {a.status}
              </Badge>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
